/* Talas PDP: Left/Right emphasis, mobile sticky buy bar. Product templates only. */
(function () {
  'use strict';
  /* Left/Right variant emphasis: follows the theme's own "swatch-change" event */
  function sideFrom(form) {
    var vals = [];
    form.querySelectorAll('select.single-option-selector').forEach(function (s) { vals.push(s.value); });
    form.querySelectorAll('input[data-single-option-selector]:checked').forEach(function (i) { vals.push(i.value); });
    for (var k = 0; k < vals.length; k++) {
      if (/\b(left|lh)\b/i.test(vals[k])) return 'left';
      if (/\b(right|rh)\b/i.test(vals[k])) return 'right';
    }
    return '';
  }
  function initSides() {
    var line = document.querySelector('[data-pdp-partline][data-pdp-sides="true"]');
    var form = document.querySelector('.js-swatch-form');
    if (!line || !form) return;
    form.addEventListener('swatch-change', function () {
      var side = sideFrom(form);
      if (side) line.setAttribute('data-active-side', side); else line.removeAttribute('data-active-side');
    });
  }

  /* Variant-aware condition line (chip in the buy box + "Condition" row in Part details). The text per variant ("ct") is rendered
     server-side by snippets/talas-cond-text.liquid into script[data-pdp-variants], so JS only swaps localised strings. */
  function initOrigin() {
    var tag = document.querySelector('script[data-pdp-variants]');
    var form = document.querySelector('.js-swatch-form');
    if (!tag || !form) return;
    var data;
    try { data = JSON.parse(tag.textContent).variants; } catch (e) { return; }
    var originChip = document.querySelector('[data-pdp-origin-chip]');
    var condChip = document.querySelector('[data-pdp-cond-chip]');
    var condDd = document.querySelector('[data-pdp-spec-cond]');
    function currentVals() {
      var vals = [];
      form.querySelectorAll('select.single-option-selector').forEach(function (e) { vals[+e.getAttribute('data-option-position') - 1] = e.value; });
      form.querySelectorAll('input[data-single-option-selector]:checked').forEach(function (e) { vals[+e.getAttribute('data-option-position') - 1] = e.value; });
      return vals;
    }
    function current() {
      try { data = JSON.parse(tag.textContent).variants; } catch (e) {}
      var vals = currentVals(), keys = Object.keys(data);
      if (!vals.length) return data[keys[0]];
      for (var i = 0; i < keys.length; i++) {
        var o = data[keys[i]].o || [], ok = o.length > 0;
        for (var j = 0; j < o.length; j++) if (vals[j] !== undefined && vals[j] !== o[j]) ok = false;
        if (ok) return data[keys[i]];
      }
      return null;
    }
    function set(chip, text) { if (!chip) return; chip.textContent = text || ''; chip.hidden = !text; }
    function apply() {
      var v = current();
      if (!v) return;
      set(originChip, v.origin === 'Genuine Tesla' ? T('origin_genuine', 'Genuine Tesla') : v.origin === 'Aftermarket' ? T('origin_aftermarket', 'Aftermarket') : '');
      if (typeof v.ct === 'string') {
        set(condChip, typeof v.cts === 'string' ? v.cts : v.ct);
        if (condDd) { condDd.textContent = v.ct; var row = condDd.closest('[data-pdp-spec-cond-row]'); if (row) row.hidden = !v.ct; if (v.fs) { var fsp = document.createElement('span'); fsp.className = 'pdp-final-sale pdp-final-sale--spec'; fsp.setAttribute('data-pdp-final-spec', ''); fsp.textContent = v.fs; condDd.appendChild(fsp); } }
      }
    }
    /* MARKET-PER-VARIANT (2026-10-30): variant metafield talas.market_spec -> per-variant Fit chip, Fits-tab region row and "Fits every model" line (strings pre-rendered in script[data-pdp-variants]) */
    function applyMarket() {
      var v = current();
      if (!v || typeof v.mk !== 'string') return;
      var li = document.querySelector('[data-pdp-market-chip]');
      if (li) { li.innerHTML = v.mk; li.style.display = v.mk ? '' : 'none'; }
      var gs = document.querySelector('[data-pdp-gens-summary]');
      if (gs) gs.hidden = !!v.mkr;
      var rg = document.querySelector('[data-pdx-market-region]');
      if (rg) {
        var c = rg.querySelector('[data-pdx-market-chip]'), nn = rg.querySelector('[data-pdx-market-note]');
        if (c) c.innerHTML = v.mks || '';
        if (nn) nn.innerHTML = v.mkn || '';
        rg.style.display = v.mks ? '' : 'none';
      }
    }
    function soon() { apply(); applyMarket(); setTimeout(function () { apply(); applyMarket(); }, 0); }
    form.addEventListener('swatch-change', soon);
    form.addEventListener('change', soon);
    document.addEventListener('pdp-both-change', soon);
  }

  /* Mobile sticky bar */
  function initSticky() {
    var bar = document.querySelector('[data-pdp-sticky]');
    var wrapper = document.querySelector('.js-product-wrapper');
    var form = document.querySelector('.js-product-wrapper .product-form');
    if (!bar || !wrapper || !form || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width:767.98px)');
    var priceEl = wrapper.querySelector('.js-product-price');
    var priceOut = bar.querySelector('[data-pdp-sticky-price]');
    var statusOut = bar.querySelector('[data-pdp-sticky-status]');
    var cta = bar.querySelector('[data-pdp-sticky-cta]');
    var ctaOut = false;
    function sync() {
      if (priceEl && priceOut) priceOut.textContent = priceEl.textContent.trim();
      var st = wrapper.getAttribute('data-status');
      var main = st === 'out-stock' ? wrapper.querySelector('.btn-pre-order') : wrapper.querySelector('.js-btn-add-to-cart .btn-label');
      if (main && cta) cta.textContent = main.textContent.replace(/\s+/g, ' ').trim();
      if (statusOut) statusOut.textContent = st === 'out-stock' ? T('sold_out', 'Sold out') : (pdpBoth ? T('left_right_set', 'Left + Right set') : '');
    }
    function apply() {
      var show = mq.matches && ctaOut;
      if (show && !document.documentElement.classList.contains('pdp-sticky-on')) {
        var pb = parseFloat(getComputedStyle(document.body).paddingBottom) || 0;
        document.documentElement.style.setProperty('--pdp-body-pb', pb + 'px');
      }
      document.documentElement.classList.toggle('pdp-sticky-on', show);
      bar.classList.toggle('is-visible', show);
    }
    var io = new IntersectionObserver(function (entries) {
      var en = entries[entries.length - 1];
      /* only after the CTA has scrolled ABOVE the viewport (not while it is still below the fold) */
      ctaOut = !en.isIntersecting && en.boundingClientRect.bottom < 0;
      apply();
    }, { threshold: 0 });
    io.observe(form);
    new MutationObserver(sync).observe(wrapper, { attributes: true, attributeFilter: ['data-status'] });
    if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true, attributes: true });
    var mainBtnObs = wrapper.querySelector('.js-btn-add-to-cart .btn-label');
    if (mainBtnObs) new MutationObserver(sync).observe(mainBtnObs, { childList: true, characterData: true, subtree: true });
    if (mq.addEventListener) mq.addEventListener('change', apply);
    cta.addEventListener('click', function () {
      var st = wrapper.getAttribute('data-status');
      var target = st === 'out-stock' ? wrapper.querySelector('.btn-pre-order') : wrapper.querySelector('.js-btn-add-to-cart');
      if (!target) return;
      if (st === 'out-stock') {
        target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' });
      }
      target.click();
    });
    document.addEventListener('pdp-both-change', sync);
    sync();
  }

  /* ================= v3: gallery, lightbox, sections, effects ================= */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  /* UI strings: window.TalasI18n (rendered from locale keys in theme.liquid); the English literal is the fallback */
  function T(k, d, a) { var s = (window.TalasI18n && window.TalasI18n[k]) || d; if (a) for (var p in a) s = s.split('%' + p + '%').join(a[p]); return s; }
  function L(v) { var k = String(v || '').toLowerCase().replace(/ /g, '_'); return T('lbl_' + k, v); }
  function isRtl() { return document.dir === 'rtl'; }
  /* RTL: forward key/swipe directions invert */
  function fwdKey() { return isRtl() ? 'ArrowLeft' : 'ArrowRight'; }
  function backKey() { return isRtl() ? 'ArrowRight' : 'ArrowLeft'; }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function initGallery() {
    var g = document.querySelector('[data-pdx-gallery]');
    if (!g) return;
    var track = g.querySelector('[data-pdx-track]');
    var slides = qa('[data-pdx-slide]', g);
    var thumbs = qa('[data-pdx-thumb]', g);
    var rail = g.querySelector('[data-pdx-thumbs]');
    var prev = g.querySelector('[data-pdx-prev]');
    var next = g.querySelector('[data-pdx-next]');
    var curEl = g.querySelector('[data-pdx-cur]');
    var n = slides.length, cur = 0, ticking = false;
    if (!track || !n) return;
    /* per-variant photos (opt-in via tag photos:per-variant -> data-pdx-vphotos): keep the full lists, show only the slides of the selected variant */
    var allSlides = slides.slice(), allThumbs = thumbs.slice(), rebuildItems = function () {};
    var vph = g.hasAttribute('data-pdx-vphotos');

    function setActive(i) {
      cur = i;
      thumbs.forEach(function (t, k) {
        if (k === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
      if (curEl) curEl.textContent = String(i + 1);
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
      var t = thumbs[i];
      if (t && rail) {
        if (rail.scrollHeight > rail.clientHeight + 2) {
          var top = t.offsetTop - rail.offsetTop - (rail.clientHeight - t.offsetHeight) / 2;
          rail.scrollTop = Math.max(0, top);
        } else if (rail.scrollWidth > rail.clientWidth + 2 && isRtl()) {
          rail.scrollLeft += (t.getBoundingClientRect().left + t.offsetWidth / 2) - (rail.getBoundingClientRect().left + rail.clientWidth / 2);
        } else if (rail.scrollWidth > rail.clientWidth + 2) {
          rail.scrollLeft = Math.max(0, t.offsetLeft - rail.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2);
        }
      }
    }
    function goTo(i, instant) {
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: (isRtl() ? -1 : 1) * i * track.clientWidth, behavior: (reduceMotion || instant) ? 'auto' : 'smooth' });
      setActive(i);
    }
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(Math.abs(track.scrollLeft) / Math.max(1, track.clientWidth));
        if (i !== cur && i >= 0 && i < n) setActive(i);
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === fwdKey()) { e.preventDefault(); goTo(cur + 1); }
      else if (e.key === backKey()) { e.preventDefault(); goTo(cur - 1); }
    });
    allThumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(thumbs.indexOf(t)); }); });
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); });
    window.addEventListener('resize', function () { track.scrollLeft = (isRtl() ? -1 : 1) * cur * track.clientWidth; });
    setActive(0);

    /* variant -> its featured image */
    var mapTag = g.querySelector('[data-pdx-variant-media]');
    var vmap = {};
    try { vmap = JSON.parse(mapTag.textContent) || {}; } catch (e) {}
    var form = document.querySelector('.js-swatch-form');
    function selVariantId() {
      var sel = document.getElementById('selected_variant');
      return String((sel && sel.value) || g.getAttribute('data-pdx-sel') || '');
    }
    /* Photo convention: an image whose alt ends in " - <option> / <option>" (every part one of this product's option values,
       e.g. "... - Used / With sensors") shows only while the selected variant has all of those values. Images without such a
       suffix (diagrams, shared photos) always show. Never leaves the gallery empty. */
    var enVars = null, enTried = false;
    /* ALT-ALIAS (2026-10-30): a suffix token may list alternatives "A | B"; known = every alternative is an option value, matches = the variant has ANY of them. Tokens without "|" behave as before. */
    function tokOpts(x) { return String(x).split('|').map(function (y) { return y.trim().toLowerCase(); }).filter(Boolean); }
    function applyVariantPhotos() {
      /* On translated pages (e.g. /ar) option values are localized but alt suffixes are English: use the default-language product JSON then */
      var vs = enVars || (window.theme && theme.product && theme.product.variants) || [], id = selVariantId(), v = null, i;
      for (i = 0; i < vs.length; i++) if (String(vs[i].id) === id) { v = vs[i]; break; }
      if (!v) return;
      var known = {}, mine = {};
      vs.forEach(function (x) { (x.options || []).forEach(function (o) { known[String(o).toLowerCase()] = 1; }); });
      (v.options || []).forEach(function (o) { mine[String(o).toLowerCase()] = 1; });
      var vis = [], vt = [], show = [];
      allSlides.forEach(function (s, k) {
        var im = s.querySelector('img'), alt = im ? (im.getAttribute('alt') || '') : '', p = alt.lastIndexOf(' - '), ok = true;
        if (p > -1) {
          var tk = alt.slice(p + 3).split(' / ').map(function (x) { return x.trim().toLowerCase(); });
          if (tk.length && tk.every(function (x) { return tokOpts(x).every(function (y) { return known[y]; }); })) ok = tk.every(function (x) { return tokOpts(x).some(function (y) { return mine[y]; }); });
        }
        show.push(ok);
      });
      if (!enVars && !enTried && allSlides.some(function (s) {
        var im = s.querySelector('img'), alt = im ? (im.getAttribute('alt') || '') : '', p = alt.lastIndexOf(' - ');
        if (p < 0 || alt.indexOf(' / ', p) < 0) return false;
        return !alt.slice(p + 3).split(' / ').every(function (x) { return tokOpts(x).every(function (y) { return known[y]; }); });
      })) {
        enTried = true;
        fetch('/products/' + location.pathname.split('/products/')[1].split(/[?#\/]/)[0] + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); }).then(function (j) { enVars = j.variants; applyVariantPhotos(); goTo(0, true); }).catch(function () {});
      }
      if (show.indexOf(true) < 0) show = show.map(function () { return true; });
      allSlides.forEach(function (s, k) {
        var li = allThumbs[k] && allThumbs[k].closest('li');
        s.style.display = show[k] ? '' : 'none';
        if (li) li.style.display = show[k] ? '' : 'none';
        if (show[k]) { vis.push(s); if (allThumbs[k]) vt.push(allThumbs[k]); }
      });
      slides = vis; thumbs = vt; n = vis.length;
      slides.forEach(function (s, k) {
        s.setAttribute('data-pdx-slide', k);
        var b = s.querySelector('[data-pdx-open]'); if (b) b.setAttribute('data-pdx-open', k);
      });
      thumbs.forEach(function (t, k) { t.setAttribute('data-pdx-thumb', k); });
      g.setAttribute('data-count', n);
      var tot = g.querySelector('[data-pdx-total]'); if (tot) tot.textContent = String(n);
      var multi = n > 1, cnt = g.querySelector('.pdx-stage__count');
      /* the thumbnail rail keeps its space (CSS [data-pdx-solo] hides it with visibility) so a one-photo variant never moves the page */
      [prev, next, cnt].forEach(function (el) { if (el) el.style.display = multi ? '' : 'none'; });
      if (multi) g.removeAttribute('data-pdx-solo'); else g.setAttribute('data-pdx-solo', '');
      rebuildItems();
    }
    if (vph) { applyVariantPhotos(); track.scrollLeft = 0; setActive(0); }
    if (form) form.addEventListener('swatch-change', function () {
      setTimeout(function () {
        if (vph) { applyVariantPhotos(); goTo(0, true); return; }
        var sel = document.getElementById('selected_variant');
        var id = sel && sel.value;
        if (id && vmap[id] != null && vmap[id] < n) goTo(vmap[id]);
      }, 0);
    });

    /* lightbox */
    var lb = g.querySelector('[data-pdx-lb]');
    if (!lb) return;
    var lbImg = lb.querySelector('[data-pdx-lb-img]');
    var lbCount = lb.querySelector('[data-pdx-lb-count]');
    var closeBtn = lb.querySelector('[data-pdx-lb-close]');
    var lbPrev = lb.querySelector('[data-pdx-lb-prev]');
    var lbNext = lb.querySelector('[data-pdx-lb-next]');
    var items = [];
    rebuildItems = function () {
      items = [];
      slides.forEach(function (s, k) {
        var im = s.querySelector('img[data-full]');
        if (im) items.push({ slide: k, full: im.getAttribute('data-full'), alt: im.getAttribute('alt') || '', cut: im.hasAttribute('data-cut') });
      });
      lbPrev.hidden = items.length < 2; lbNext.hidden = items.length < 2;
    };
    rebuildItems();
    if (!items.length) return;
    var pos = 0, opener = null, lbHome = lb.parentNode, lbScroll = 0;
    function show(p) {
      pos = (p + items.length) % items.length;
      var it = items[pos];
      lbImg.classList.remove('is-zoomed');
      lbImg.classList.toggle('is-cut', !!it.cut); lb.classList.toggle('is-cut', !!it.cut);
      lbImg.src = it.full; lbImg.alt = it.alt;
      lbCount.textContent = items.length > 1 ? (pos + 1) + ' / ' + items.length : '';
      var nx = items[(pos + 1) % items.length]; if (nx) { var pi = new Image(); pi.src = nx.full; }
    }
    function open(slideIndex, from) {
      var p = 0;
      items.forEach(function (it, k) { if (it.slide === slideIndex) p = k; });
      opener = from || document.activeElement;
      /* Portal to <body>: inside .pdx-gallery (isolation:isolate) the overlay's z-index is trapped in that stacking context,
         so the sticky buy box and the header paint above it. As a direct child of <body> it is a true full-viewport overlay. */
      lbScroll = window.pageYOffset;
      document.body.appendChild(lb);
      lb.hidden = false;
      document.documentElement.classList.add('pdx-lb-open');
      show(p);
      closeBtn.focus();
    }
    function close() {
      if (lb.hidden) return;
      lb.hidden = true;
      document.documentElement.classList.remove('pdx-lb-open');
      lbImg.removeAttribute('src');
      if (lbHome && lb.parentNode !== lbHome) lbHome.appendChild(lb);
      goTo(items[pos].slide, true);
      window.scrollTo({ top: lbScroll, left: 0, behavior: 'instant' });
      if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); } }
    }
    qa('[data-pdx-open]', g).forEach(function (b) {
      b.addEventListener('click', function () { open(+b.getAttribute('data-pdx-open'), b); });
    });
    closeBtn.addEventListener('click', close);
    lbPrev.addEventListener('click', function () { show(pos - 1); });
    lbNext.addEventListener('click', function () { show(pos + 1); });
    lbImg.addEventListener('click', function (e) {
      var r = lbImg.getBoundingClientRect();
      lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      lbImg.classList.toggle('is-zoomed');
    });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.hasAttribute('data-pdx-lb-fig')) close(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
      else if (e.key === fwdKey()) { show(pos + 1); }
      else if (e.key === backKey()) { show(pos - 1); }
      else if (e.key === 'Tab') {
        var f = qa('button', lb).filter(function (b) { return !b.hidden; });
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === fwdKey() && !lb.contains(document.activeElement)) show(pos + 1);
      else if (e.key === backKey() && !lb.contains(document.activeElement)) show(pos - 1);
    });
    /* focus trap: if focus lands outside the open viewer (e.g. the chat widget), bring it back */
    document.addEventListener('focusin', function (e) {
      if (!lb.hidden && !lb.contains(e.target)) closeBtn.focus();
    });
    var sx = null;
    lb.addEventListener('touchstart', function (e) { sx = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (sx === null || lbImg.classList.contains('is-zoomed')) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 50) show(pos + ((dx < 0) !== isRtl() ? 1 : -1));
    }, { passive: true });
  }

  function initEffects() {
    var hasIO = 'IntersectionObserver' in window;
    /* lazy section backgrounds */
    var bgs = qa('[data-bg]');
    function loadBg(el) {
      var v = el.getAttribute('data-bg'); if (!v) return;
      el.style.backgroundImage = v; el.removeAttribute('data-bg');
      requestAnimationFrame(function () { el.classList.add('is-bg'); });
    }
    if (hasIO) {
      var bio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { loadBg(e.target); bio.unobserve(e.target); } });
      }, { rootMargin: '300px 0px' });
      bgs.forEach(function (b) { bio.observe(b); });
    } else { bgs.forEach(loadBg); }

    /* scroll reveal removed (2026-10-26): every section renders at full opacity on load, so crawlers, link previews and
       full-page captures never see a blank state. [data-reveal] stays in the markup only as a hook. */

    /* parallax: transform only, rAF, only while near the viewport, 0.2-0.3x */
    if (hasIO && !reduceMotion) {
      var px = qa('[data-parallax]').map(function (el) { return { el: el, host: el.parentNode, k: parseFloat(el.getAttribute('data-parallax')) || 0.25, on: false }; });
      var vis = 0, raf = 0;
      var pio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          px.forEach(function (p) { if (p.host === e.target) p.on = e.isIntersecting; });
        });
        schedule();
      }, { rootMargin: '120px 0px' });
      px.forEach(function (p, i) { if (px.findIndex(function (q) { return q.host === p.host; }) === i) pio.observe(p.host); });
      var frame = function () {
        raf = 0;
        var vh = window.innerHeight;
        px.forEach(function (p) {
          if (!p.on) return;
          var r = p.host.getBoundingClientRect();
          var off = (r.top + r.height / 2 - vh / 2) * p.k;
          p.el.style.transform = 'translate3d(0,' + (-off).toFixed(1) + 'px,0)';
        });
      };
      function schedule() { if (!raf) raf = requestAnimationFrame(frame); }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      schedule();
    }

    /* anchor strip: sticky offset + scroll-margin + scroll-spy share ONE offset (header bottom + bar height + 16) */
    var below = document.querySelector('[data-pdx-below]');
    var bar = document.querySelector('[data-pdx-anchor]');
    var links = qa('.pdx-anchor__link');
    var secs = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    if (!below || !bar || !links.length) return;
    var root = document.documentElement, GAP = 16, STICK_GAP = 10;
    var mask = document.createElement('div');
    mask.className = 'pdx-anchor-mask'; mask.setAttribute('aria-hidden', 'true');
    below.insertBefore(mask, below.firstChild); /* inside .pdx-below's stacking context so the bar (z30) stays above it */
    var M = { off: 0, stick: 0, barH: 0, cur: null };
    function headerBottom() {
      /* the fixed header (desktop pill wrapper .tc-bar, mobile .header-content_top): its top gap + height, transform-free */
      var els = qa('.tc-bar, .header-content_top'), best = 0;
      els.forEach(function (h) {
        var cs = getComputedStyle(h);
        if (cs.position !== 'fixed' || cs.display === 'none' || !h.offsetHeight) return;
        best = Math.max(best, (parseFloat(cs.top) || 0) + h.offsetHeight);
      });
      return best;
    }
    function measure() {
      var hb = headerBottom();
      /* NAVBAR-BACKDROP: mask is full viewport width via CSS; no per-column sizing */
      M.barH = bar.offsetHeight;
      M.stick = Math.round(hb + STICK_GAP);
      M.off = M.stick + M.barH + GAP;
      root.style.setProperty('--pdx-stick', M.stick + 'px');
      root.style.setProperty('--pdx-scroll-offset', M.off + 'px');
      root.style.setProperty('--pdx-mask-h', (M.stick + M.barH + 8) + 'px');
      tail();
      spy();
    }
    function headOf(s) { return s && (s.querySelector('.pdx-sec__head') || s); }
    /* the last section is short: keep enough room below so its heading can reach the offset instead of ending under the bars */
    function tail() {
      var last = secs[secs.length - 1], h = headOf(last);
      if (!h) return;
      var cur = parseFloat(root.style.getPropertyValue('--pdx-tail')) || 0;
      var docH = root.scrollHeight - cur;
      var headY = h.getBoundingClientRect().top + window.pageYOffset;
      var need = Math.ceil(Math.max(0, headY - M.off + window.innerHeight - docH));
      if (Math.abs(need - cur) > 1) root.style.setProperty('--pdx-tail', need + 'px');
    }
    function spy() {
      var bTop = below.getBoundingClientRect();
      mask.classList.toggle('is-on', bar.getBoundingClientRect().top <= M.stick + 1 && bTop.bottom > M.stick + M.barH);
      var id = secs[0] && secs[0].id, y = window.pageYOffset, max = root.scrollHeight - window.innerHeight;
      secs.forEach(function (s) {
        var h = headOf(s);
        if (h && h.getBoundingClientRect().top <= M.off + GAP + 8) id = s.id;
      });
      if (y >= max - 2 && secs[secs.length - 1] && bTop.top < window.innerHeight) id = secs[secs.length - 1].id;
      if (typeof jump !== 'undefined' && jump.sec && Date.now() < jump.until) id = jump.sec.id; /* a clicked tab stays active while its jump runs */
      if (id === M.cur) return;
      M.cur = id;
      links.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        if (on) { a.setAttribute('aria-current', 'true'); var l = a.parentNode.parentNode; if (l.scrollWidth > l.clientWidth) l.scrollLeft = a.offsetLeft - (l.clientWidth - a.offsetWidth) / 2; }
        else a.removeAttribute('aria-current');
      });
    }
    var spyRaf = 0;
    function spySoon() { if (!spyRaf) spyRaf = requestAnimationFrame(function () { spyRaf = 0; spy(); }); }
    /* QA fix: deterministic anchor jump. The layout grows mid-scroll (lazy images, fonts), so a native jump / one-shot smooth scroll can land low.
       Compute the target from getBoundingClientRect, scroll via Lenis (or smooth scrollTo), then re-check after ~400ms and after images load. */
    var jump = { sec: null, until: 0, tries: 0 };
    function smoothLib() { var s = window.__tsmooth; return (s && s.lenis) || window.lenis || null; }
    function jumpDelta() { var h = headOf(jump.sec); return h ? (h.getBoundingClientRect().top - M.off) : 0; }
    function jumpTo(immediate) {
      var y = Math.max(0, Math.round(headOf(jump.sec).getBoundingClientRect().top + window.pageYOffset - M.off)); /* the heading, as spy() measures it */
      var L = smoothLib();
      if (L && !L.isStopped && typeof L.scrollTo === 'function') {
        L.scrollTo(y, { immediate: !!immediate });
        window.dispatchEvent(new Event('scroll')); /* wakes the talas-smooth rAF loop */
      } else window.scrollTo({ top: y, behavior: immediate ? 'auto' : 'smooth' });
    }
    function jumpCheck() {
      if (!jump.sec || Date.now() > jump.until) return;
      var L = smoothLib();
      if (L && L.isScrolling && jump.tries < 12) { jump.tries++; setTimeout(jumpCheck, 150); return; }
      if (Math.abs(jumpDelta()) > 8) jumpTo(true);
    }
    links.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        var s = secs[i];
        if (!s || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        jump.sec = s; jump.until = Date.now() + 3000; jump.tries = 0;
        measure(); spy();
        jumpTo(false);
        if (history.pushState) history.pushState(null, '', a.getAttribute('href'));
        setTimeout(jumpCheck, 400);
        setTimeout(jumpCheck, 1100);
      });
    });
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, function () { if (jump.sec) { jump.until = 0; spySoon(); } }, { passive: true }); });
    below.addEventListener('load', function () { if (jump.sec && Date.now() < jump.until) { jump.tries = 0; setTimeout(jumpCheck, 60); } }, true);
    window.addEventListener('load', function () { if (jump.sec && Date.now() < jump.until) setTimeout(jumpCheck, 60); });
    measure();
    window.addEventListener('scroll', spySoon, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(measure);
      ro.observe(bar); ro.observe(root);
      qa('.tc-bar, .header-content_top').forEach(function (h) { ro.observe(h); });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  /* today's hours for the three branches (Asia/Dubai); the static text stays if Intl is unavailable */
  function initBranches() {
    var cards = qa('[data-pdx-branch]');
    if (!cards.length || !window.Intl || !Intl.DateTimeFormat) return;
    var keys = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    var names = { sun: T('day_sun', 'Sunday'), mon: T('day_mon', 'Monday'), tue: T('day_tue', 'Tuesday'), wed: T('day_wed', 'Wednesday'), thu: T('day_thu', 'Thursday'), fri: T('day_fri', 'Friday'), sat: T('day_sat', 'Saturday') };
    function now() {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Dubai', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      return { day: keys.indexOf(String(o.weekday).slice(0, 3).toLowerCase()), min: (+o.hour % 24) * 60 + (+o.minute) };
    }
    function tm(s) { var a = s.split(':'); return +a[0] * 60 + +a[1]; }
    function fmt(s) { return s.replace(/^0/, ''); }
    function range(w) { var a = w.split('-'); return T('hours_range', '%a% to %b%', { a: fmt(a[0]), b: fmt(a[1]) }); }
    var t;
    try { t = now(); } catch (e) { return; }
    if (t.day < 0) return;
    cards.forEach(function (c) {
      var hours; try { hours = JSON.parse(c.getAttribute('data-hours')); } catch (e) { return; }
      var out = c.querySelector('[data-pdx-hours]'); if (!out) return;
      var today = hours[keys[t.day]] || [], open = false, status = '', nextToday = null;
      today.forEach(function (w) {
        var a = w.split('-');
        if (t.min >= tm(a[0]) && t.min < tm(a[1])) { open = true; status = T('open_now_until', 'Open now, until %t%', { t: fmt(a[1]) }); }
        else if (t.min < tm(a[0]) && !nextToday) nextToday = a[0];
      });
      var line;
      if (open) line = T('today_hours', 'Today %r%', { r: today.map(range).join(', ') });
      else if (nextToday) { status = T('opens_today_at', 'Opens today at %t%', { t: fmt(nextToday) }); line = T('today_hours', 'Today %r%', { r: today.map(range).join(', ') }); }
      else {
        var d = 1, nd = null;
        for (; d <= 7; d++) { var k = keys[(t.day + d) % 7]; if ((hours[k] || []).length) { nd = k; break; } }
        status = nd ? T('closed_opens', 'Closed now, opens %d% at %t%', { d: (d === 1 ? T('tomorrow', 'tomorrow') : names[nd]), t: fmt(hours[nd][0].split('-')[0]) }) : T('closed', 'Closed');
        line = today.length ? T('today_hours', 'Today %r%', { r: today.map(range).join(', ') }) : T('closed_today', 'Closed today');
      }
      out.textContent = '';
      var s1 = document.createElement('strong'); s1.textContent = status; s1.style.display = 'block'; s1.style.fontWeight = '600';
      var s2 = document.createElement('span'); s2.textContent = line; s2.style.color = 'var(--t-muted,#566679)';
      out.appendChild(s1); out.appendChild(s2);
      c.classList.toggle('is-open', open);
    });
  }

  /* compatible parts (tag match on the first model) + recently viewed (localStorage) */
  function initMore() {
    var root = document.querySelector('[data-pdx-more]');
    if (!root) return;
    var handle = root.getAttribute('data-handle'), tag = root.getAttribute('data-tag');
    var grid = root.querySelector('[data-pdx-more-grid]');
    var inner = grid && grid.closest('.pdx-more__inner');
    var KEY = 'talas_pdp_rv';
    var L = { from: root.getAttribute('data-l-from') || '', sold: root.getAttribute('data-l-sold') || '', ask: root.getAttribute('data-l-ask') || '' };

    /* values read back from localStorage are untrusted: only same-site paths / https URLs are allowed (blocks javascript: and data: URLs) */
    function safeU(u) { u = String(u || ''); if (!/^(\/|https:\/\/)/.test(u)) return '#'; var lm = u.match(/^\/(?:[a-z]{2}(?:-[A-Za-z]{2,4})?\/)?(products\/.*)$/); return lm ? ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + lm[1] : u; }
    function safeI(u) { u = String(u || ''); return /^(https:\/\/|\/\/|\/)/.test(u) ? u : ''; }
    function card(o, small) {
      var li = document.createElement('li'); li.className = 'pdx-card' + (o.sold ? ' pdx-card--soldout' : ''); /* same rule as the catalogue card: tc--soldout (unavailable / Ask / on-demand) */
      var a = document.createElement('a'); a.className = 'pdx-card__link'; a.href = safeU(o.u);
      var im = document.createElement('span'); im.className = 'pdx-card__img' + (o.c ? ' pdx-card__img--cut' : '');
      if (safeI(o.i)) { var img = document.createElement('img'); var si = safeI(o.i); if (/[?&]width=\d+/.test(si)) { /* CWV 2026-11-02: card box is 155-278 px, give the browser a ladder instead of one 360-480 px file */ img.srcset = [240, 300, 360, 480].map(function (w) { return si.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w'; }).join(', '); img.sizes = small ? '(min-width: 992px) 200px, (min-width: 561px) 31vw, 44vw' : '(min-width: 992px) 278px, 44vw'; } img.src = si; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async'; img.width = 360; img.height = 360; im.appendChild(img); }
      var b = document.createElement('span'); b.className = 'pdx-card__body';
      var t = document.createElement('span'); t.className = 'pdx-card__title'; t.textContent = String(o.t == null ? '' : o.t);
      b.appendChild(t);
      if (!small) { /* Option A: one muted line (conditions you can buy, or "Sold out"), never a stock count */
        /* the SAME tags as the catalogue cards: markup copied from the fetched card (snippets/talas-cond-pills.liquid), same CSS classes */
        var mt = document.createElement('span'); mt.className = 'tc__pills pdx-card__meta';
        if (o.sold) { var sp = document.createElement('span'); sp.className = 'tc__pill tc__pill--sold'; sp.textContent = L.sold; mt.appendChild(sp); }
        else if (o.pl) { mt.innerHTML = o.pl.replace(/^\s*<div[^>]*>|<\/div>\s*$/g, ''); }
        b.appendChild(mt);
      }
      var row = document.createElement('span'); row.className = 'pdx-card__row';
      if (!small) { var fr = document.createElement('span'); fr.className = 'pdx-card__from'; fr.textContent = (o.f && L.from) ? L.from : '\u00a0'; row.appendChild(fr); }
      var p = document.createElement('span'); p.className = 'pdx-card__price' + (o.p && !/[\d\u0660-\u0669]/.test(String(o.p)) ? ' pdx-card__price--ask' : ''); /* no digit = the Ask label: calm style in talas-ask-price.css */ var pt = String(o.p == null ? '' : o.p).trim(); if (!pt && !o.sold && L.ask) pt = L.ask; /* a blank price line is the Ask label, never empty */ p.className = 'pdx-card__price' + (pt && !/[\d\u0660-\u0669]/.test(pt) ? ' pdx-card__price--ask' : ''); p.textContent = pt.replace(/(\d)\.00(?!\d)/g, '$1'); /* whole dirhams never show ".00" (also for entries saved earlier) */
      row.appendChild(p); b.appendChild(row); a.appendChild(im); a.appendChild(b); li.appendChild(a);
      return li;
    }
    function fill(list, items, small) {
      list.textContent = '';
      items.forEach(function (o) { list.appendChild(card(o, small)); });
      list.removeAttribute('aria-busy');
    }

    /* recently viewed (owner 2026-11-02): the cards are the SAME catalogue card as everywhere else. Each entry is re-read from
       /products/<handle>?view=card (templates/product.card.liquid renders snippets/product-item.liquid) and parsed by parse(), exactly like the
       More-parts cards, so price / Ask label / condition chips / cutout can never drift from the catalogue. A 404 (draft, archived, deleted)
       drops the entry. Entries are cached in localStorage for 6 h (v:2); older entries are refreshed on first sight. */
    function rv() {
      var list = [];
      try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); if (!Array.isArray(list)) list = []; } catch (e) { list = []; }
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var me = { h: handle, t: root.getAttribute('data-title') || '', i: root.getAttribute('data-img') || '', p: root.getAttribute('data-price') || '', c: root.hasAttribute('data-cut') ? 1 : 0, u: root.getAttribute('data-url') || ('/products/' + handle), ts: 0, v: 0 };
      var others = list.filter(function (x) { return x && x.h && x.h !== handle; });
      function save() { try { localStorage.setItem(KEY, JSON.stringify([me].concat(others).slice(0, 12))); } catch (e) {} }
      save();
      var box = root.querySelector('[data-pdx-rv]'), g = root.querySelector('[data-pdx-rv-grid]');
      if (!box || !others.length) return;
      var revealed = false;
      function show() {
        var items = others.slice(0, 6);
        if (!items.length) { box.hidden = true; return; }
        fill(g, items, false);
        box.hidden = false;
        if (!revealed) { revealed = true; if (box.hasAttribute('data-reveal') && document.documentElement.classList.contains('pdx-js')) { requestAnimationFrame(function () { box.classList.add('is-in'); }); } }
      }
      var now = Date.now();
      var cand = others.slice(0, 8);
      var stale = cand.filter(function (x) { return x.v !== 2 || !x.ts || now - x.ts > 21600000; });
      function one(x) {
        return fetch(rootUrl + 'products/' + encodeURIComponent(x.h) + '?view=card', { credentials: 'same-origin' }).then(function (r) {
          if (r.status === 404 || r.status === 410) return 'gone';
          if (!r.ok) throw new Error(r.status);
          return r.text();
        }).then(function (html) {
          if (html === 'gone') return 'gone';
          var it = parse(html).filter(function (y) { return y.u.indexOf('/products/' + x.h) > -1; })[0]; if (!it) throw new Error('nocard');
          it.h = x.h; it.ts = Date.now(); it.v = 2; return it;
        }).catch(function () { return null; });
      }
      if (!stale.length) { show(); return; }
      /* entries that were never read from the card (no v) have no chips and may have a blank price: wait for the card before showing them */
      var needWait = cand.some(function (x) { return x.v !== 2; });
      if (!needWait) show();
      Promise.all(stale.map(one)).then(function (res) {
        res.forEach(function (r, k) {
          var idx = others.indexOf(stale[k]); if (idx < 0) return;
          if (r === 'gone') others.splice(idx, 1);
          else if (r) others[idx] = r;
          else if (others[idx].v !== 2) others[idx].nocard = 1;
        });
        /* a card that could not be read (network) stays only if it has a usable price line already */
        others = others.filter(function (x) { return !x.nocard || String(x.p || '').trim(); });
        save(); show();
      });
    }
    try { rv(); } catch (e) {}

    /* compatible parts */
    var loaded = false;
    function parse(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var out = [];
      /* supports the catalogue card (.tc) and the legacy theme card (.product-card) */
      qa('article.tc, .product-card', doc).forEach(function (c) {
        var a = c.querySelector('.tc__title a, .product-card_name a'); if (!a) return;
        var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/); if (!m || m[1] === handle) return;
        var img = c.querySelector('img'), src = '';
        if (img) src = (img.getAttribute('data-srcset') || '').replace('{width}', '360') || img.getAttribute('src') || '';
        var pr = c.querySelector('.tc__now') || c.querySelector('.tc__price, .product-price'), mp = c.getAttribute('data-more-price'); /* .tc__now = current price only (the whole .tc__price also holds the struck-through compare-at, which printed as "300.00Dhs. 350.00") */
        out.push({ c: !!c.querySelector('.tc__img--cut'), u: ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + m[1], t: a.textContent.replace(/\s+/g, ' ').trim(), i: src, p: mp || (pr ? pr.textContent.replace(/\s+/g, ' ').trim() : ''), pl: (c.querySelector('.tc__pills') || {}).innerHTML || '', f: c.getAttribute('data-more-from') === '1', sold: c.classList.contains('tc--soldout') || !!c.querySelector('.tc__out, .soldout') });
      });
      return out;
    }
    function get(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(parse); }
    function load() {
      if (loaded || !grid) return; loaded = true;
      var base = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'collections/tesla';
      /* list order 2026-11-02: a model tag that is also a vehicle collection (model-3/y/s/x, cybertruck) reads that collection first: it is merchandised
         fitment-first (buyable meaningful parts, then Ask, hardware last; tools/catalog/order_collections.py). Other tags keep the Tesla tag path. */
      var vehicle = /^(model-[3ysx]|cybertruck)$/.test(tag || '') ? get(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'collections/' + tag + '?view=ajax-request').catch(function () { return []; }) : Promise.resolve([]);
      var first = tag ? vehicle.then(function (v) { return v.length ? v : get(base + '/' + encodeURIComponent(tag) + '?view=ajax-request'); }) : Promise.resolve([]);
      first.catch(function () { return []; }).then(function (items) {
        if (items.length) return items;
        /* no tagged matches: fall back to the Tesla range and say so */
        return get(base + '?view=ajax-request').then(function (all) {
          var h = document.getElementById('pdp-more-h'), note = root.querySelector('.pdx-more__note');
          if (h) h.textContent = T('more_parts', 'More Tesla parts');
          if (note) note.textContent = T('more_parts_note', 'Parts from our Tesla range. These are not matched to a specific vehicle.');
          return all;
        });
      }).then(function (items) {
        items = items.slice(0, 8);
        if (!items.length) { if (inner) inner.hidden = true; return; }
        fill(grid, items, false);
      }).catch(function () { if (inner) inner.hidden = true; });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { load(); io.disconnect(); } }, { rootMargin: '700px 0px' });
      io.observe(root);
    } else { load(); }
    /* also fill the grid once the page has loaded, so the section is never left as blank skeletons (crawlers, link previews,
       full-page captures that never scroll) */
    var idle = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 1200); })(load, { timeout: 2500 }); };
    if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
  }

  /* ================= Segmented option control + "Both (set)" =================
     The theme's native select / radio inputs stay the source of truth (hidden): a click sets them and fires "change",
     so linkOptions -> handleVariantChange keeps driving URL ?variant=, price, stock, SKU, pickup, add-to-cart id.
     "Both (set)" is a theme-side pseudo-option for Left/Right: it never touches the native inputs or ?variant=;
     it only overrides price / compare-at / stock state / part-number highlight / button on top of the last real variant. */
  var pdpBoth = false;

  function initSegmented() {
    var form = document.querySelector('.js-swatch-form');
    var wrapper = document.querySelector('.js-product-wrapper');
    if (!form || !wrapper) return;
    var groups = qa('[data-pdp-seg]', form);
    if (!groups.length) return;
    var variants = (window.theme && theme.product && theme.product.variants) || [];
    var priceEl = wrapper.querySelector('.js-product-price');
    var compareEl = wrapper.querySelector('.js-compare-at-price');
    var saleEl = wrapper.querySelector('.js-label_ui-sale');
    var btnLabel = wrapper.querySelector('.js-btn-add-to-cart .btn-label');
    var addBtn = wrapper.querySelector('.js-btn-add-to-cart');
    var addForm = wrapper.querySelector('.js-form-add-to-card');
    var line = document.querySelector('[data-pdp-partline]');
    var bothGroup = form.querySelector('[data-pdp-seg-side]');
    var note = bothGroup ? form.querySelector('[data-pdp-seg-note]') : null;
    var bothBtn = bothGroup ? bothGroup.querySelector('[data-pdp-both]') : null;
    var sideInfo = null; /* {pos, left, right} option strings of the Left and Right segments */
    var bothAvail = false;
    var busy = false;

    function opts(g) { return qa('.pdp-seg__opt:not([data-pdp-both])', g); }
    function itemOf(g) { return g.closest('.js-swatch-item'); }
    function posOf(g) { return +g.getAttribute('data-option-position'); }

    /* native read / write */
    function nativeVal(g) {
      var it = itemOf(g), sel = it.querySelector('select.single-option-selector');
      if (sel) return sel.value;
      var chk = it.querySelector('input[data-single-option-selector]:checked');
      return chk ? chk.value : '';
    }
    function setNative(g, val) {
      var it = itemOf(g), sel = it.querySelector('select.single-option-selector');
      if (sel) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
      var inputs = qa('input[data-single-option-selector]', it);
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === val) { inputs[i].checked = true; inputs[i].dispatchEvent(new Event('change', { bubbles: true })); return; }
      }
    }
    function selectedVals() {
      var vals = [];
      groups.forEach(function (g) { vals[posOf(g) - 1] = nativeVal(g); });
      /* options without a segmented group (dropdown >4 values, colour swatches) */
      qa('.js-swatch-item', form).forEach(function (it) {
        var p = +it.getAttribute('data-position') - 1;
        if (vals[p] !== undefined) return;
        var sel = it.querySelector('select.single-option-selector');
        var chk = it.querySelector('input[data-single-option-selector]:checked');
        vals[p] = sel ? sel.value : (chk ? chk.value : undefined);
      });
      return vals;
    }
    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options, ok = true;
        for (var j = 0; j < o.length; j++) if (vals[j] !== undefined && vals[j] !== o[j]) ok = false;
        if (ok) return variants[i];
      }
      return null;
    }

    /* paint: thumb index, aria, roving tabindex */
    function paint(g, idx) {
      var all = qa('.pdp-seg__opt', g), vis = all.filter(function (b) { return !b.hidden; });
      var vi = vis.indexOf(all[idx]);
      g.style.setProperty('--i', vi < 0 ? 0 : vi);
      g.style.setProperty('--n', vis.length || 1);
      g.classList.toggle('is-single', vis.length === 1); /* BUYBOX-CASCADE: one valid value = plain selected pill */
      all.forEach(function (b, k) {
        var on = k === idx;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = (on && vis.length > 1) ? 0 : -1;
      });
    }
    function paintFromNative() {
      groups.forEach(function (g) {
        var v = nativeVal(g), os = opts(g), idx = 0;
        os.forEach(function (b, k) { if (b.getAttribute('data-pdp-seg-value') === v) idx = k; });
        if (g === bothGroup && pdpBoth) idx = os.length;
        paint(g, idx);
      });
    }

    /* BUYBOX-CASCADE: a value of option k is offered only if a variant exists with the earlier options as selected (hidden otherwise);
       a value that exists but has no available variant stays visible and struck through ("sold out" words only for the selected one). */
    function variantsFor(p, val, vals) {
      return variants.filter(function (v) {
        if (v.options[p] !== val) return false;
        for (var j = 0; j < p; j++) if (vals[j] !== undefined && v.options[j] !== vals[j]) return false;
        return true;
      });
    }
    function nativeOfItem(it) {
      var sel = it.querySelector('select.single-option-selector');
      if (sel) return sel.value;
      var chk = it.querySelector('input[data-single-option-selector]:checked');
      return chk ? chk.value : '';
    }
    function setQuiet(it, val) { /* set a native option without firing events: the one real "change" comes from the option the customer touched */
      var sel = it.querySelector('select.single-option-selector');
      if (sel) { sel.value = val; return; }
      qa('input[data-single-option-selector]', it).forEach(function (i) { i.checked = i.value === val; });
    }
    function cascadeNative(vals) { /* dropdowns / colour swatches without a segmented control */
      qa('.js-swatch-item', form).forEach(function (it) {
        if (it.querySelector('[data-pdp-seg]')) return;
        var p = +it.getAttribute('data-position') - 1, sel = it.querySelector('select.single-option-selector');
        if (sel) { qa('option', sel).forEach(function (o) { var ex = variantsFor(p, o.value, vals).length > 0; o.hidden = !ex; o.disabled = !ex; }); return; }
        qa('input[data-single-option-selector]', it).forEach(function (i) { var w = i.closest('.input-group') || i.parentNode; w.hidden = variantsFor(p, i.value, vals).length === 0; });
      });
    }
    function refreshAvailability() {
      var vals = selectedVals();
      groups.forEach(function (g) {
        var p = posOf(g) - 1, shown = 0;
        opts(g).forEach(function (b) {
          var m = variantsFor(p, b.getAttribute('data-pdp-seg-value'), vals), ex = m.length > 0;
          b.hidden = !ex; if (ex) shown++;
          var out = ex && !m.some(function (v) { return v.available; });
          b.classList.toggle('is-unavailable', out);
          var sr = b.querySelector('.pdp-seg__sr');
          if (sr) { var so = out && b.getAttribute('aria-checked') === 'true'; sr.textContent = so ? ' (' + T('sold_out', 'Sold out') + ')' : ''; sr.hidden = !so; }
        });
        if (!shown) opts(g).forEach(function (b) { b.hidden = false; }); /* never leave a picker empty */
      });
      cascadeNative(vals);
      if (bothBtn && sideInfo) { var pr = sidePair(); bothBtn.hidden = !(pr && pr.left && pr.right); } /* no set when one side never exists */
    }
    /* closest real variant for a changed option: keep the later choices that are still valid (earlier positions first), else jump */
    function nearest(p0, want) {
      var best = null, bs = -1;
      variants.forEach(function (v) {
        var n = v.options.length, j, s = 0;
        for (j = 0; j <= p0; j++) if (v.options[j] !== want[j]) return;
        for (j = p0 + 1; j < n; j++) if (v.options[j] === want[j]) s += Math.pow(2, n - j);
        if (v.available) s += 0.5;
        if (s > bs) { bs = s; best = v; }
      });
      return best;
    }
    function settle(p0, val) { /* returns the swatch items whose native value was moved */
      var want = selectedVals(), moved = [];
      want[p0] = val;
      if (findVariant(want)) return moved;
      var best = nearest(p0, want);
      if (!best) return moved;
      qa('.js-swatch-item', form).forEach(function (it) {
        var j = +it.getAttribute('data-position') - 1;
        if (j === p0 || nativeOfItem(it) === best.options[j]) return;
        setQuiet(it, best.options[j]); moved.push(it);
      });
      return moved;
    }
    var liveEl = null;
    function announce(items) { /* polite, from labels already on the page (no new copy): "Finish: As removed" */
      if (!items || !items.length) return;
      if (!liveEl) { liveEl = document.createElement('p'); liveEl.className = 'pdp-seg__sr'; liveEl.setAttribute('role', 'status'); liveEl.setAttribute('aria-live', 'polite'); form.appendChild(liveEl); }
      liveEl.textContent = items.map(function (it) {
        var t = it.querySelector('.swatch-title'), v = nativeOfItem(it), g = it.querySelector('[data-pdp-seg]'), lab = v;
        if (g) { var b = qa('.pdp-seg__opt', g).filter(function (x) { return x.getAttribute('data-pdp-seg-value') === v; })[0], l = b && b.querySelector('.pdp-seg__label'); if (l) lab = l.textContent.trim(); }
        return (t ? t.textContent.trim() + ': ' : '') + lab;
      }).join('. ');
    }

    /* Both: pair of variants for the current selection of the OTHER options */
    function sidePair() {
      if (!sideInfo) return null;
      var vals = selectedVals(), a = vals.slice(), b = vals.slice();
      a[sideInfo.pos - 1] = sideInfo.left; b[sideInfo.pos - 1] = sideInfo.right;
      return { left: findVariant(a), right: findVariant(b) };
    }
    function refreshBothAvail() {
      if (!bothBtn) return;
      var pr = sidePair(), why = '';
      bothAvail = !!(pr && pr.left && pr.right && pr.left.available && pr.right.available);
      if (!bothAvail) {
        if (!pr || !pr.left || !pr.right) why = T('why_no_set', 'No matching set for this selection');
        else if (!pr.left.available && !pr.right.available) why = T('why_both_sold', 'Both sides sold out');
        else if (!pr.left.available) why = T('why_left_sold', 'Left side sold out');
        else why = T('why_right_sold', 'Right side sold out');
      }
      bothBtn.setAttribute('aria-disabled', bothAvail ? 'false' : 'true');
      bothBtn.classList.toggle('is-disabled', !bothAvail);
      if (why) bothBtn.setAttribute('title', why); else bothBtn.removeAttribute('title');
      bothBtn.setAttribute('data-reason', why);
      if (note) setNote(pdpBoth ? T('set_note', 'Adds one Left and one Right, sold as a set.') : why, !bothAvail && !pdpBoth);
    }
    function setNote(txt, warn) {
      if (!note) return;
      note.textContent = txt || '';
      note.classList.toggle('is-warn', !!warn);
      note.classList.toggle('is-on', !!txt);
    }

    /* Both display overrides (applied on top of the theme's last real-variant render) */
    function money(c) { return typeof c.toCurrency === 'function' ? c.toCurrency() : (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
    function applyBoth() {
      var pr = sidePair();
      if (!pdpBoth) return;
      if (!pr || !pr.left || !pr.right || !pr.left.available || !pr.right.available) { exitBoth(); return; }
      var sum = pr.left.price + pr.right.price;
      var cmp = (pr.left.compare_at_price || pr.left.price) + (pr.right.compare_at_price || pr.right.price);
      wrapper.classList.add('pdp-both-on');
      wrapper.setAttribute('data-status', 'in-stock');
      if (priceEl) {
        if (typeof Currencies !== 'undefined') priceEl.setAttribute('data-money', sum); else priceEl.innerHTML = money(sum);
      }
      if (compareEl) {
        if (cmp > sum) {
          if (typeof Currencies !== 'undefined') compareEl.setAttribute('data-money', cmp); else compareEl.innerHTML = money(cmp);
          compareEl.classList.remove('d-none');
          if (saleEl && saleEl.getAttribute('data-style') !== 'none') {
            saleEl.classList.remove('d-none');
            if (saleEl.getAttribute('data-style') === 'percent') saleEl.innerHTML = '-' + Math.round((cmp - sum) * 100 / cmp) + '%';
          }
        } else {
          compareEl.classList.add('d-none');
          if (saleEl) saleEl.classList.add('d-none');
        }
      }
      if (btnLabel) btnLabel.textContent = T('add_both', 'Add both to cart');
      if (line) line.setAttribute('data-active-side', 'both');
      setNote(T('set_note', 'Adds one Left and one Right, sold as a set.'), false);
      document.dispatchEvent(new CustomEvent('pdp-both-change'));
    }
    function enterBoth() {
      if (!bothBtn) return;
      if (!bothAvail) { bumpNote(); return; }
      pdpBoth = true;
      paintFromNative();
      applyBoth();
    }
    function bumpNote() {
      if (!note) return;
      note.classList.remove('is-bump'); void note.offsetWidth; note.classList.add('is-bump');
    }
    function exitBoth() {
      if (!pdpBoth) return;
      pdpBoth = false;
      wrapper.classList.remove('pdp-both-on');
      if (line) { var s = sideFrom(form); if (s) line.setAttribute('data-active-side', s); else line.removeAttribute('data-active-side'); }
      paintFromNative();
      document.dispatchEvent(new CustomEvent('pdp-both-change'));
    }

    /* user picks a real segment */
    function pick(g, b) {
      if (b.hasAttribute('data-pdp-both')) { enterBoth(); return; }
      var val = b.getAttribute('data-pdp-seg-value');
      var wasBoth = pdpBoth && g === bothGroup;
      if (wasBoth) { pdpBoth = false; wrapper.classList.remove('pdp-both-on'); }
      /* BUYBOX-CASCADE: later options keep their value if it still exists for this choice, otherwise jump to the nearest real variant */
      var moved = settle(posOf(g) - 1, val);
      paint(g, opts(g).indexOf(b));
      /* when leaving Both the native value is unchanged, but we still fire "change" so the theme re-renders the real variant */
      setNative(g, val);
      announce(moved);
      if (wasBoth) document.dispatchEvent(new CustomEvent('pdp-both-change'));
    }

    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.pdp-seg__opt');
        if (!b || !g.contains(b)) return;
        pick(g, b);
      });
      g.addEventListener('keydown', function (e) {
        var k = e.key, all = qa('.pdp-seg__opt', g).filter(function (x) { return x.getAttribute('aria-disabled') !== 'true' && !x.hidden; });
        var cur = all.indexOf(document.activeElement);
        if (cur < 0) cur = Math.max(0, all.findIndex(function (x) { return x.getAttribute('aria-checked') === 'true'; }));
        var nxt = -1;
        if (k === fwdKey() || k === 'ArrowDown') nxt = (cur + 1) % all.length;
        else if (k === backKey() || k === 'ArrowUp') nxt = (cur - 1 + all.length) % all.length;
        else if (k === 'Home') nxt = 0;
        else if (k === 'End') nxt = all.length - 1;
        else return;
        e.preventDefault();
        all[nxt].focus();
        pick(g, all[nxt]);
      });
    });

    /* theme finished a real variant change: resync */
    function onSwatch() {
      refreshAvailability();
      refreshBothAvail();
      if (pdpBoth) { applyBoth(); requestAnimationFrame(applyBoth); }
      paintFromNative();
      refreshAvailability(); /* after aria-checked is repainted: sold-out words only on the selected option */
    }
    form.addEventListener('swatch-change', onSwatch);
    form.addEventListener('change', function (e) {
      var it = e.target && e.target.closest && e.target.closest('.js-swatch-item');
      if (!it || it.querySelector('[data-pdp-seg]')) return;
      announce(settle(+it.getAttribute('data-position') - 1, nativeOfItem(it)));
    }, true);

    /* Add both to cart: capture phase so it runs before the theme's own submit handler */
    document.addEventListener('submit', function (e) {
      if (!pdpBoth || !addForm || e.target !== addForm) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (busy) return;
      var pr = sidePair();
      if (!pr || !pr.left || !pr.right) return;
      busy = true;
      if (addBtn) addBtn.classList.add('pending');
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: pr.left.id, quantity: 1 }, { id: pr.right.id, quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function () {
        /* items are in the cart from here on: a failed refresh must never read as a failed add */
        return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; });
      }).then(function (cart) {
        if (!window.Cart) { window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart'; return; }
        if (cart) {
          Cart.value = cart;
          document.querySelectorAll('.js-cart-items-count').forEach(function (n) { n.innerHTML = cart.item_count; });
          document.querySelectorAll('.js-cart-icon-total-money').forEach(function (n) {
            if (typeof Currencies !== 'undefined') n.setAttribute('data-money', cart.total_price); else n.innerHTML = money(cart.total_price);
          });
        }
        if (!Cart.drawer) { window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart'; return; } /* cart type is not the drawer */
        Cart.drawerLoaded = false; /* force the drawer to re-read the cart so it lists both lines */
        document.dispatchEvent(new CustomEvent('open-cart-drawer'));
      }).catch(function (err) {
        setNote((err && (err.description || err.message)) || T('add_failed', 'Could not add both items. Please try again.'), true);
        bumpNote();
      }).then(function () {
        busy = false;
        if (addBtn) addBtn.classList.remove('pending');
      });
    }, true);

    /* init */
    if (bothGroup) {
      var os = opts(bothGroup), L = null, R = null;
      os.forEach(function (b) {
        var v = b.getAttribute('data-pdp-seg-value'), l = v.trim().toLowerCase();
        if (l === 'left') L = v; else if (l === 'right') R = v;
      });
      if (L && R) sideInfo = { pos: posOf(bothGroup), left: L, right: R };
      else if (bothBtn) bothBtn.hidden = true;
    }
    refreshAvailability();
    refreshBothAvail();
    paintFromNative();
    refreshAvailability();
  }

  /* "See branches & hours" opens the same pickup drawer as the buy box (one drawer, no copy).
     The line itself is shown by CSS only once the buy-box trigger exists (it renders asynchronously). */
  function initPickupLink() {
    qa('[data-pdx-open-pickup]').forEach(function (l) {
      l.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation(); /* the drawer closes on outside clicks; this one must not bubble to it */
        var b = document.getElementById('ShowPickupAvailabilityDrawer');
        if (b) b.click();
      });
    });
  }

  /* ================= Sold-out delivery line =================
     Buy-box delivery row and the compact "Delivery & pickup" line each hold a normal and a sold-out text (server-rendered for
     the selected variant). On every variant change, including the Left / Right / Both toggle, show the one that matches.
     Both (set) counts as sold out when either side is. */
  function initDelivery() {
    var rows = qa('[data-pdp-deliv]');
    var form = document.querySelector('.js-swatch-form');
    var variants = (window.theme && theme.product && theme.product.variants) || [];
    if (!rows.length || !form || !variants.length) return;
    var side = form.querySelector('[data-pdp-seg-side]');
    var bothBtn = side ? side.querySelector('[data-pdp-both]') : null;
    var bothIntent = false; /* user pressed Both while it was unavailable */
    function vals() {
      var v = [];
      form.querySelectorAll('select.single-option-selector').forEach(function (e) { v[+e.getAttribute('data-option-position') - 1] = e.value; });
      form.querySelectorAll('input[data-single-option-selector]:checked').forEach(function (e) { v[+e.getAttribute('data-option-position') - 1] = e.value; });
      return v;
    }
    function match(v) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options, ok = true;
        for (var j = 0; j < o.length; j++) if (v[j] !== undefined && v[j] !== o[j]) ok = false;
        if (ok) return variants[i];
      }
      return null;
    }
    function sideVariants() {
      var L = null, R = null, pos = +side.getAttribute('data-option-position');
      qa('.pdp-seg__opt:not([data-pdp-both])', side).forEach(function (b) {
        var x = b.getAttribute('data-pdp-seg-value'), l = x.trim().toLowerCase();
        if (l === 'left') L = x; else if (l === 'right') R = x;
      });
      if (!L || !R) return null;
      var a = vals(), b = vals(); a[pos - 1] = L; b[pos - 1] = R;
      return [match(a), match(b)];
    }
    function soldOut() {
      if (side && (pdpBoth || bothIntent)) {
        var pr = sideVariants();
        if (pr) return !(pr[0] && pr[1] && pr[0].available && pr[1].available);
      }
      var v = match(vals());
      return v ? !v.available : false;
    }
    function apply() {
      var s = soldOut();
      rows.forEach(function (r) {
        qa('[data-deliv-normal]', r).forEach(function (e) { e.hidden = s; });
        var tplEl = r.querySelector('script[data-deliv-sold-tpl]'), tpl = null;
        try { tpl = tplEl ? JSON.parse(tplEl.textContent) : null; } catch (x) { tpl = null; }
        qa('[data-deliv-sold]', r).forEach(function (e) {
          /* sold-out sentence exists in the DOM only while the selected variant is sold out */
          if (s && tpl && !e.firstElementChild && !/\S/.test(e.textContent)) e.innerHTML = tpl;
          else if (!s) e.textContent = '';
          e.hidden = !s;
        });
      });
    }
    form.addEventListener('swatch-change', function () { bothIntent = false; apply(); setTimeout(apply, 0); });
    document.addEventListener('pdp-both-change', function () { bothIntent = false; apply(); });
    if (bothBtn) bothBtn.addEventListener('click', function () { setTimeout(function () { bothIntent = !pdpBoth && bothBtn.getAttribute('aria-disabled') === 'true'; apply(); }, 0); });
    apply();
  }


  /* 2026-10-19: decide per photo whether it is a white-background shot (keep light frame) or a scene photo (dark studio). */
  function sceneSlides() {
    var slides = document.querySelectorAll('.pdx-slide:not(.pdx-slide--cut)');
    [].forEach.call(slides, function (li) {
      var img = li.querySelector('.pdx-slide__img'); if (!img) return;
      function test() {
        try {
          var n = 24, c = document.createElement('canvas'); c.width = c.height = n;
          var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, n, n);
          var d = x.getImageData(0, 0, n, n).data, edge = 0, light = 0;
          for (var y = 0; y < n; y++) for (var k = 0; k < n; k++) {
            if (y > 1 && y < n - 2 && k > 1 && k < n - 2) continue;
            var i = (y * n + k) * 4; edge++;
            if (Math.min(d[i], d[i + 1], d[i + 2]) > 222) light++;
          }
          if (light / edge < 0.5) li.classList.add('pdx-slide--scene');
        } catch (e) {}
      }
      if (img.complete && img.naturalWidth) test(); else img.addEventListener('load', test, { once: true });
    });
  }

  /* 2026-10-26 layout helpers.
     1. Tabs strip: data-fade-start / data-fade-end while labels are scrolled out of view (CSS draws the edge fade), so a row that
        overflows on a narrow phone shows it scrolls instead of clipping labels.
     2. Desktop sticky buy box: when it is taller than the viewport, stick with a negative top so its bottom (share row) stays reachable. */
  function initLayout() {
    var list = document.querySelector('.pdx-anchor__list');
    if (list) {
      var fade = function () {
        var max = list.scrollWidth - list.clientWidth, x = Math.abs(list.scrollLeft);
        var a = max > 2 && x > 2, b = max > 2 && x < max - 2;
        if (isRtl()) { var t = a; a = b; b = t; }
        list.toggleAttribute('data-fade-start', a);
        list.toggleAttribute('data-fade-end', b);
      };
      list.addEventListener('scroll', fade, { passive: true });
      window.addEventListener('resize', fade);
      if (window.ResizeObserver) new ResizeObserver(fade).observe(list);
      fade();
    }
    var buy = document.getElementById('pdp-buy');
    if (buy) {
      var mq = window.matchMedia('(min-width:992px)');
      var fit = function () {
        if (!mq.matches) { buy.style.removeProperty('--pdx-buy-top'); return; }
        var top = parseFloat(getComputedStyle(document.querySelector('.product-template')).getPropertyValue('--pdx-top')) || 88;
        var room = window.innerHeight - buy.offsetHeight - 16;
        buy.style.setProperty('--pdx-buy-top', Math.round(Math.min(top, room)) + 'px');
      };
      window.addEventListener('resize', fit);
      if (window.ResizeObserver) new ResizeObserver(fit).observe(buy);
      fit();
    }
  }

  /* "+N" on the Substitutes rows: opens the remaining part numbers (they are in the HTML; CSS hides them only while JS runs) */
  function initPnMore() {
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-pn-more-btn]'); if (!b) return;
      var w = b.closest('[data-pn-more]'); if (!w) return;
      w.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); b.hidden = true;
    });
  }
  function init() { initPnMore(); initLayout(); initDelivery(); initPickupLink(); initSides(); initSegmented(); initOrigin(); initSticky(); initGallery(); sceneSlides(); initEffects(); initBranches(); initMore(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
